import React, { useState, useEffect } from 'react';
// @material-ui/core components
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import Pagination from '@material-ui/lab/Pagination';
import { Link } from 'react-router-dom';
import {
    Table,
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter
} from 'reactstrap';
import { makeStyles } from '@material-ui/core/styles';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
// core components
import { connect } from 'react-redux';
import { getAllTransactions } from '../../store/actions/admin/Admin';
import CardHeader from '../../components/Card/CardHeader.js';
import { Input } from '@material-ui/core';
import VisibilityIcon from '@material-ui/icons/Visibility';
const PAGE_LIMIT = 2000
const styles = {
    typo: {
        paddingLeft: '25%',
        marginBottom: '40px',
        position: 'relative'
    },
    note: {
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        bottom: '10px',
        color: '#c0c1c2',
        display: 'block',
        fontWeight: '400',
        fontSize: '13px',
        lineHeight: '13px',
        left: '0',
        marginLeft: '20px',
        position: 'absolute',
        width: '260px'
    },
    cardCategoryWhite: {
        color: 'rgba(255,255,255,.62)',
        margin: '0',
        fontSize: '14px',
        marginTop: '0',
        marginBottom: '0'
    },
    cardTitleWhite: {
        color: '#FFFFFF',
        marginTop: '0px',
        minHeight: 'auto',
        fontWeight: '300',
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        marginBottom: '3px',
        textDecoration: 'none'
    }
};

const useStyles = makeStyles(styles);

const UsersTable = (props) => {
    const classes = useStyles();
    const [modal, setModal] = useState(false);
    const [walletModal, setWalletModal] = useState(false);
    const [modal2, setModal2] = useState(false);
    const [walletMoney, setWalletMoney] = useState(null)
    const [page, setPage] = useState(1);

    const toggle = () => setModal(!modal);
    const toggleWallet = () => setWalletModal(!walletModal);
    const toggle2 = () => setModal2(!modal2);

    const [itemDelete, setItemDelete] = useState(0);
    const [itemId, setItemId] = useState(null);

    useEffect(() => {
        props.getAllTransactions(1, 10000, props.match.params.id);
    }, []);

    const handleWalletMoneyAdd = (id) => {
        props.addWalletAmount(id, walletMoney).then((data) => {
            if (data) {
                setWalletMoney(null)
                props.getAllUsers(1);
            }
        });
    }
    return (
        <>
            <CardHeader color="primary">
                <h4 className={classes.cardTitleWhite}>
                    Transactions
        </h4>
            </CardHeader>
            <Table hover>
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Amount</th>
                        <th>Added/Spend</th>
                        <th>Added By Admin</th>
                        <th>Status</th>
                        <th>Date</th>
                    </tr>
                </thead>
                <tbody>
                    {props.userTransactions?.map((item, i) => (
                        <tr key={item.id}>
                            <th scope="row">{i + 1 + (page ? (page - 1) * PAGE_LIMIT : 0)}</th>
                            <td>{item.amount}</td>
                            <td>{item.addedToWallet ? 'Added' : 'Spend'}</td>
                            <td>{item.addedByAdmin ? 'true' : 'false'}</td>
                            <td>{item.status}</td>
                            <td>{new Date(item.createdAt).toLocaleString()}</td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </>
    );
};

const mapStateWithProps = (state) => ({
    userTransactions: state.admin.userTransactions,
});
const mapDispatchWithProps = (dispatch) => {
    return {
        getAllTransactions: (pageNumber, count, id) => dispatch(getAllTransactions(pageNumber, count, id)),
    };
};

export default connect(mapStateWithProps, mapDispatchWithProps)(UsersTable);
